<template>
  <i aria-hidden="true" class="v-icon notranslate material-icons theme--light">
    {{ status }}
  </i>
</template>

<script>
const BUTTON_CONTENT_SIGN = 'done';
const NORMAL_CONTENT_SIGN = 'block';

export default {
  name: "ButtonField",
  props: {
    item: {}
  },
  computed: {
    status() {
      return this.item.buttonContent === 'BUTTON_CONTENT' ? BUTTON_CONTENT_SIGN : NORMAL_CONTENT_SIGN;
    }
  }
}
</script>
